import React from 'react';
import { validateUrlParams } from 'utils/Helper';
import {
    APP_PATH,
    ANBEFALET,
    ANBEFALET_SPORT_ID,
    LIVE_CASINO,
    LIVE_ID,
    REST_EUROPE_ID,
    REST_WORLD_ID,
    SOON_ID,
    BIG_NINE,
    ANOTHER_SPORTS_ID,
    ANOTHER_SPORTS_PATH,
    ANOTHER_GROUPS_ID,
    ANOTHER_GROUPS_PATH,
    SPORTS,
} from 'constants/appConfig';
import {
    DANMARK_ID,
    goToWithBasePath,
    REST_EUROPE_PATH,
    REST_WORLD_PATH,
} from '../../constants/appConfig';
import renderHTML from 'react-render-html';
import { browserHistory } from 'react-router';

export const specialRoutes = {
    [LIVE_ID]: 'live',
    [SOON_ID]: 'pre',
    [LIVE_CASINO]: 'live-casino',
    [BIG_NINE]: 'big9',
    [ANOTHER_SPORTS_ID]: ANOTHER_SPORTS_PATH,
};

const specialSportsPaths = {
    [ANOTHER_GROUPS_ID]: ANOTHER_GROUPS_PATH,
    [REST_EUROPE_ID]: REST_EUROPE_PATH,
    [REST_WORLD_ID]: REST_WORLD_PATH,
};

export const buildPathBySportItem = (item, pathname) => {
    let sportPath = pathname[1] || '';
    let groupPath = pathname[2] || '';

    let newPath = '/';

    if (item?.id in specialRoutes) {
        return goToWithBasePath(`/${specialRoutes[item.id]}`);
    }

    if (item?.id in specialSportsPaths) {
        return goToWithBasePath(`/${sportPath}/${specialSportsPaths[item.id]}`);
    }

    const itemName = validateUrlParams(item.name);

    if (item.type === 1) {
        const listNotEmpty = item.itemList && item.itemList?.length > 0;
        const priorityItems = listNotEmpty
            ? item.itemList.filter(
                  (itemEvent) => itemEvent.priority && itemEvent.count > 0
              )
            : [];

        if (listNotEmpty && !priorityItems.length) {
            newPath = `/${itemName}/${ANOTHER_GROUPS_PATH}`;
        } else if (priorityItems.length) {
            newPath = `/${itemName}/${validateUrlParams(
                priorityItems[0].name
            )}`;
        } else {
            newPath = `/${itemName}`;
        }
    } else if (item.type === 2) {
        newPath = `/${sportPath}/${itemName}`;
    } else if (item.type === 3) {
        newPath = `/${sportPath}/${groupPath}/${itemName}`;
    }

    return goToWithBasePath(newPath);
};

export const getIconName = (item) => {
    if (
        [
            SOON_ID,
            LIVE_CASINO,
            ANBEFALET,
            BIG_NINE,
            ANOTHER_SPORTS_ID,
            SPORTS.LEAGUE_OF_LEGENDS,
        ].includes(item.id)
    ) {
        return item.name;
    }
    if (item.id === LIVE_ID) {
        return <span>Live</span>;
    }
    if (item.id === SPORTS.SPECIALS) {
        return 'Specials';
    }

    if (item.name.includes('Resten ')) {
        return renderHTML(item.name);
    }
    return renderHTML(item.name.replace(' ', '<br />'));
};

export const getIconPath = (item, selectedSport) => {
    if (selectedSport) {
        return APP_PATH + '/img/sports/' + selectedSport.id + '.png';
    } else {
        if (item.id === ANBEFALET_SPORT_ID) {
            return APP_PATH + '/img/sports/' + 'for-dig' + '.png';
        } else {
            return APP_PATH + '/img/sports/' + item.id + '.png';
        }
    }
};

export const getCountryName = (data) => {
    let countryName = data.name
        .toLowerCase()
        .replace(' ', '.')
        .replace('- ', '');

    if (data.id === REST_EUROPE_ID || data.id === REST_WORLD_ID) {
        countryName = data.id;
    }

    if (data.id === DANMARK_ID) {
        countryName = 'danmark';
    }

    return countryName;
};

export const onClickBackBtnHandler = (activeSport = 0) => {
    if (activeSport && activeSport?.priority === 0) {
        browserHistory.push(`/sport/${ANOTHER_SPORTS_PATH}`);
    } else {
        browserHistory.push('/sport/');
    }
};
